import {
  useAssignSetting,
  useSetting,
} from "@faire/web--source/common/settings/__internal__/useSetting";
import { FE_BUILDER_XP_1_WITH_BOOLEAN_TYPE_250306 } from "@faire/web-settings/FE_BUILDER_XP_1_WITH_BOOLEAN_TYPE_250306";
import { FE_BUILDER_XP_2_WITH_BOOLEAN_TYPE_250306 } from "@faire/web-settings/FE_BUILDER_XP_2_WITH_BOOLEAN_TYPE_250306";
import { FE_BUILDER_XP_WITH_FOUR_VARIANTS_250306 } from "@faire/web-settings/FE_BUILDER_XP_WITH_FOUR_VARIANTS_250306";
import { FE_BUILDER_XP_WITH_THREE_VARIANTS_250306 } from "@faire/web-settings/FE_BUILDER_XP_WITH_THREE_VARIANTS_250306";

export const useSettingBuilderXp1WithBooleanType = () =>
  useSetting(FE_BUILDER_XP_1_WITH_BOOLEAN_TYPE_250306);

export const useAssignSettingBuilderXp1WithBooleanType = () =>
  useAssignSetting(FE_BUILDER_XP_1_WITH_BOOLEAN_TYPE_250306);

export const useSettingBuilderXp2WithBooleanType = () =>
  useSetting(FE_BUILDER_XP_2_WITH_BOOLEAN_TYPE_250306);

export const useAssignSettingBuilderXp2WithBooleanType = () =>
  useAssignSetting(FE_BUILDER_XP_2_WITH_BOOLEAN_TYPE_250306);

export const useSettingBuilderXpWithThreeVariants = () =>
  useSetting(FE_BUILDER_XP_WITH_THREE_VARIANTS_250306);

export const useAssignSettingBuilderXpWithThreeVariants = () =>
  useAssignSetting(FE_BUILDER_XP_WITH_THREE_VARIANTS_250306);

export const useSettingBuilderXpWithFourVariants = () =>
  useSetting(FE_BUILDER_XP_WITH_FOUR_VARIANTS_250306);

export const useAssignSettingBuilderXpWithFourVariants = () =>
  useAssignSetting(FE_BUILDER_XP_WITH_FOUR_VARIANTS_250306);
